import { TAB_TYPE_DEED, TAB_TYPE_LEASE } from '@/constants'
import { formatDate } from '@/utils/date'
import { useRef, useState } from 'react'
import { MdAdd, MdArticle, MdAutoAwesomeMosaic, MdCancel, MdCheck, MdDelete, MdEdit, MdRemove } from 'react-icons/md'
import cn from 'classnames'
import ConfirmationModal from '@/components/shared/ConfirmationModal'

const SuggestionTabsBlock = ({ block, removeDocument, renameTab, removeTab, setTabIdx }) => {
    
    const [activeRenames, setActiveRenames] = useState([])
    const [removingIdx, setRemovingIdx] = useState(null)
    const boxRef = useRef(null)
    
    const activateRename = idx => setActiveRenames([...activeRenames, idx])
    const closeRename = idx => setActiveRenames(activeRenames.filter(i => i !== idx))
    
    const updateRename = (realIdx, idx) => {
        renameTab(realIdx, boxRef.current.querySelector(`#rename-tab-${realIdx}`).value)
        closeRename(idx)
    }
    
    return (
        <div className="flex flex-col gap-2 flex-1" ref={boxRef}>
            {block.map((tab, i) =>
                <div className="collapse collapse-sm bg-base-100" key={i}>
                    <input type="checkbox" defaultChecked
                        className={cn('mr-[5.5rem] !w-[calc(100%-7.5rem)]',
                            { 'hidden': activeRenames.includes(i) })} />
                    {!activeRenames.includes(i) &&
                        <div className="collapse-title font-semibold flex items-center justify-between pe-4">
                            <div className="flex items-center">
                                {tab.type === TAB_TYPE_LEASE && <MdArticle className="text-xl mr-2" />}
                                {tab.type === TAB_TYPE_DEED && <MdAutoAwesomeMosaic className="text-xl mr-2" />}
                                {tab.name}
                            </div>
                            
                            <div className="flex gap-2 mr-3">
                                <span data-tip="Rename Tab"
                                    className="tooltip tooltip-left tooltip-accent">
                                    <button className="btn btn-xs btn-square btn-ghost"
                                        onClick={() => activateRename(i)}>
                                        <MdEdit />
                                    </button>
                                </span>
                                
                                <span data-tip="Add document to Tab"
                                    className="tooltip tooltip-left tooltip-accent">
                                    <button className="btn btn-xs btn-square btn-ghost"
                                        onClick={() => setTabIdx(tab.realIdx)}>
                                        <MdAdd />
                                    </button>
                                </span>
                                
                                <span data-tip="Remove Tab"
                                    className="tooltip tooltip-left tooltip-accent">
                                    <button className="btn btn-xs btn-square btn-ghost"
                                        onClick={() => setRemovingIdx(tab.realIdx)}>
                                        <MdDelete />
                                    </button>
                                </span>
                            </div>
                        
                        </div>}
                    
                    {activeRenames.includes(i) &&
                        <div className="collapse-title font-semibold flex items-center justify-between pe-4">
                            <div className="flex items-center flex-1">
                                {tab.type === TAB_TYPE_LEASE && <MdArticle className="text-xl mr-2" />}
                                {tab.type === TAB_TYPE_DEED && <MdAutoAwesomeMosaic className="text-xl mr-2" />}
                                <input
                                    type="text"
                                    className="input input-bordered input-sm w-full !h-auto px-2"
                                    autoFocus
                                    onKeyDown={e => {
                                        e.stopPropagation()
                                        if (e.key === 'Enter') updateRename(tab.realIdx, i)
                                        if (e.key === 'Escape') closeRename(i)
                                    }}
                                    id={`rename-tab-${tab.realIdx}`}
                                    defaultValue={tab.name} />
                            </div>
                            
                            <div className="flex gap-2 mr-3">
                                <span data-tip="Rename Tab"
                                    className="tooltip tooltip-left tooltip-accent">
                                    <button className="btn btn-xs btn-square btn-ghost"
                                        onClick={() => updateRename(tab.realIdx, i)}>
                                        <MdCheck />
                                    </button>
                                </span>
                                
                                <span data-tip="Cancel renaming"
                                    className="tooltip tooltip-left tooltip-accent">
                                    <button className="btn btn-xs btn-square btn-ghost"
                                        onClick={() => closeRename(i)}>
                                        <MdCancel />
                                    </button>
                                </span>
                            </div>
                        
                        </div>}
                    <div className="collapse-content text-sm pt-0">
                        <table className="table table-sm table-bordered table-zebra table-pin-rows">
                            <tbody>
                                {tab.documents.map(d => <tr key={d.id}>
                                    <td><span className="line-clamp-1">{d.document.name}</span></td>
                                    <td>{d.value.instrumentType}</td>
                                    <td>
                                        {d.value.instrumentDate ? formatDate(d.value.instrumentDate) : ''}
                                    </td>
                                    <td className="w-0">
                                        <span data-tip="Remove document from Tab"
                                            className="tooltip tooltip-left tooltip-accent">
                                            <button className="btn btn-xs btn-square btn-ghost"
                                                onClick={() => removeDocument(tab.realIdx, d.id)}>
                                                <MdRemove />
                                            </button>
                                        </span>
                                    </td>
                                </tr>)}
                            </tbody>
                        </table>
                    </div>
                </div>,
            )}
            <ConfirmationModal
                showHideModal={() => setRemovingIdx(null)}
                onConfirm={() => {
                    removeTab(removingIdx)
                    setRemovingIdx(null)
                }}
                showModal={removingIdx !== null}
                title="Remove Tab"
                message="Are you sure you want to remove this tab?"
                confirmButtonText="Remove"
                confirmButtonClass="btn-error" />
        </div>
    )
}

export default SuggestionTabsBlock